import { render, staticRenderFns } from "./WalletChargeSms.vue?vue&type=template&id=56006b76"
import script from "./WalletChargeSms.vue?vue&type=script&lang=js"
export * from "./WalletChargeSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports